import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { RequestService } from "src/app/services/http-service.service";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  MENUITEMS = [];

  constructor(private router: Router, public request:RequestService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }

    this.updateMenu();
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  updateMenu(){
    this.request.get('objects').then(async objects => {

      this.MENUITEMS.push({
        headTitle1: 'Objekte'
      })

      for await (let object of objects) {

        this.MENUITEMS.push(
          { path: "/object/" + object._id, title: object.name, type: "link", bookmark: true }
        )
      }

      this.MENUITEMS.push({
        headTitle1: 'Verwalten'
      },
        { path: "/objects", title: "Objekte", type: "link", bookmark: true },
        { path: "/workers", title: "Mitarbeiter", type: "link", bookmark: true },
        { path: "/admins", title: "Administratoren", type: "link", bookmark: true },
        { path: "/bookings", title: "Buchungen", type: "link", bookmark: true },
        { path: "/invoices", title: "Rechnungen", type: "link", bookmark: true },
        { path: "/clients", title: "Gäste", type: "link", bookmark: true },
        { path: "/bedtypes", title: "Bettarten", type: "link", bookmark: true },
      )

      let user = JSON.parse(localStorage.getItem('hotel_user'));

      if(user._id == user.rootId){
        this.MENUITEMS.push(
          { path: "/settings", title:'Firmeninformation', type: "link", bookmark: true }
        )
      }

      console.log(this.MENUITEMS);
      
    })
    // Array
    this.items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  }

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
